export const defaultCtas = {
  primaryCta: { label: 'Get Started', to: '/contact-us' },
} as const;

export const localImage = (path: string) => path;
